<template>
  <form v-if="!loading" class="nameform m-center" @submit="submit">
    <div v-if="validCertificate"></div>
    <div v-if="validCertificate === false">
      <h1 class="mb-6">Il tuo certificato di firma elettronica è scaduto!</h1>
      <p class="text-grey mb-10">
        Accedi al tuo home banking per rinnovarlo.
        <a
          :href="dashboardUrl"
          target="_blank"
          style=" position: relative; color: #CC4B00; text-decoration: underline;"
          >Clicca qui</a
        >
      </p>
    </div>
  </form>
  <SignatureLoader
    title="Stiamo preparando i tuoi documenti, richiederà circa 1 minuto"
    :steps="[
      'Verifica documento di identità',
      'Creazione documenti',
      'Compilazione documenti digitali'
    ]"
    v-else
    :loadingLevel="loadingLevel"
  />
</template>

<script>
import RegistrationService from "@/services/RegistrationService";
import UtilityService from "@/services/UtilityService";
import SignatureLoader from "@/modules/SignatureLoader";

export default {
  name: "RequestCertificate",
  components: {
    SignatureLoader
  },
  data() {
    return {
      validCertificate: null,
      loading: false,
      loadingLevel: 0,
      dashboardUrl: process.env.VUE_APP_DASHBOARD_URL
    };
  },

  mounted() {
    this.loading = true;
    RegistrationService.userHasValidCertificate("me").then(
      validCertificate => {
        this.loading = false;
        this.validCertificate = validCertificate;
        if (validCertificate) {
          this.submit();
        } //else: messaggio di errore gestito nell'html
      },
      error => {
        this.loading = false;
        UtilityService.showDefaultError(error);
      }
    );
  },
  methods: {
    async submit() {
      event.preventDefault();
      if (this.loading) return;
      this.loading = true;

      this.loadingLevel = 0;

      setTimeout(() => {
        const $pageElement = document.querySelector(".page");
        $pageElement.scrollTop = 0;
      }, 100);

      setTimeout(() => {
        this.loadingLevel = 1;
      }, 2000);

      setTimeout(() => {
        this.loadingLevel = 2;
      }, 7000);

      try {
        const { data: dossier } = await RegistrationService.createDossier({
          mode: "TUTOR"
        });
        const { data: startDossier } = await RegistrationService.startDossier(
          dossier
        );

        const infocertData = {
          ...dossier
        };

        this.$store.commit("setUser", {
          infocert: infocertData,
          clauses: startDossier.documents
        });

        this.loadingLevel = 3;

        setTimeout(() => {
          this.loading = false;
          this.$root.$emit("submitStep");
        }, 1000);
      } catch (error) {
        UtilityService.showDefaultError(error);
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="less" scoped></style>
